(ns client-portal.client.voice-commerce.orders.components
  (:require [clojure.string :as s]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.style :as style]
            [shared.core.util :as util]
            [shared.core.utils.currency :as currency]))

(defn money-label
  "An amount the query already converted from cents, in the tenant's currency."
  [v]
  (if (nil? v)
    "-"
    (str (currency/get-currency-symbol) (util/readable-number v))))

(def order-status->icon
  "Icon and its color per order status — the status text keeps the default cell color."
  {"completed" {:icon-type :check-circle :color "Common/success"}
   "refunded" {:icon-type :undo :color "Chart/orange"}
   "created" {:icon-type :schedule :color "Chart/tech_blue"}
   "cancelled" {:icon-type :cancel :color "Icons/secondary"}
   "failed" {:icon-type :error :color "Common/error"}})

(defn source-cell [source]
  (if (and (not-empty (str source)) (not= "-" (str source)))
    [alc/up-tag {:text (util/->capitalize-words source)}]
    "-"))

(defn status-cell [status]
  (let [{:keys [icon-type color]} (get order-status->icon (some-> status (str) (s/lower-case)))]
    [:div {:style {:display :flex
                   :align-items :center
                   :gap 6}}
     (when icon-type
       [alc/material-icon {:icon-type icon-type
                           :style {:color (style/alc-color color)
                                   :font-size 16}}])
     [:span (if (not-empty (str status))
              (util/->capitalize-words status)
              "-")]]))
